/* eslint-disable sort-imports */
/* eslint-disable max-lines */
/* eslint-disable complexity */
/* eslint-disable sort-keys */
import {
    NinchatEnvironmentConfigTheme,
} from 'embed/types'

import {
    globalCss, /* , keyframes, */
} from '@stitches/react'

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import font1 from '../../assets/fonts/open-sans-v17-latin-regular.woff2'
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import font2 from '../../assets/fonts/open-sans-v17-latin-regular.woff'

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import font1Bold from '../../assets/fonts/open-sans-v17-latin-600.woff2'
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import font2Bold from '../../assets/fonts/open-sans-v17-latin-600.woff'

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const globalStyles = (customFonts: NinchatEnvironmentConfigTheme['customFonts']) => globalCss({
    '@font-face': [
        {
            fontFamily: 'Open Sans Ninchat Embed',
            fontStyle: 'normal',
            fontWeight: 'normal',
            src: `local('Open Sans Regular'), local('OpenSans-Regular'),
                url(${font1}) format('woff2'), /* Chrome 26+, Opera 23+, Firefox 39+ */
                url(${font2}) format('woff'); /* Chrome 6+, Firefox 3.6+, IE 9+, Safari 5.1+ */`,

        },
        {
            fontFamily: 'Open Sans Ninchat Embed',
            fontStyle: 'normal',
            fontWeight: 600,
            src: `local('Open Sans SemiBold'), local('OpenSans-SemiBold'),
             url(${font1Bold}) format('woff2'), /* Chrome 26+, Opera 23+, Firefox 39+ */
             url(${font2Bold}) format('woff'); /* Chrome 6+, Firefox 3.6+, IE 9+, Safari 5.1+ */`,

        },
        ...customFonts?.map((font) => ({
            fontFamily: font.family || '',
            fontStyle: font.style || 'normal',
            fontWeight: font.weight || 'normal',
            src: font.src || '',
            ...font.ascentOverride ? {ascentOverride: font.ascentOverride} : {},
            ...font.descentOverride ? {descentOverride: font.descentOverride} : {},
            ...font.lineGapOverride ? {lineGapOverride: font.lineGapOverride} : {},
        })) || [],
    ],
})()
